/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ time: NonNullable<unknown> }} Fleet_Camera_Circuit_OpenInputs */

const vi_fleet_camera_circuit_open = /** @type {(inputs: Fleet_Camera_Circuit_OpenInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Camera xe mất kết nối (VNETGPS) — thử lại lúc ${i?.time}`)
};

/**

* @param {Fleet_Camera_Circuit_OpenInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const fleet_camera_circuit_open = /** @type {((inputs: Fleet_Camera_Circuit_OpenInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fleet_Camera_Circuit_OpenInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_fleet_camera_circuit_open(inputs)
});